<template>
  <div class="pe-question-wrapper">
    <h3 :class="['pe-default-title', globalConfig.classes?.title]">
      {{ question.question.title }}
      <span v-if="question.is_required" class="pe-question-title">*</span>
    </h3>

    <template v-for="type in activeTypes" :key="type">
      <component :is="QuestionFactory.getComponent(type)" :question="question" :group-type="type"/>
    </template>

    <span v-if="error" :class="['pe-error-msg', globalConfig.classes?.questionError]">{{ error }}</span>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue';
import { QuestionFactory } from '../../utils/QuestionFactory';

const props = defineProps({
  question: { type: Object, required: true },
  error: { type: String, default: null },
});

const globalConfig = inject('engineConfig');

const activeTypes = computed(() => {
  const groups = props.question.optionGroups;
  if (!groups) return ['text']; // Fallback seguro

  const typesPresent = Object.keys(groups);

  // Return only types that have a registered explicit component (using fallback on render if needed)
  return typesPresent.filter(type => QuestionFactory.hasComponent(type) && groups[type].length > 0);
});
</script>

<style scoped>
.pe-question-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--pe-q-wrapper-gp, 1.67vh);
}

.pe-question-title {
  color: var(--pe-error-color, #d32f2f);
}
</style>